<div class=" body_container text-grey">
  <app-component-navigation></app-component-navigation>
  <div class="row h-97 ms-1 w-100">
    <div class="w-100 d-flex flex-column h-100 p-0">
      <div class="topPanel marginForLogs d-none">
        <h2 class="mainHeading">Monitor Jobs - </h2>
        <h4><span class="bi bi-layers"></span> {{ depName }}</h4>
        <button type="button" class="default-btn" title="Refresh Details" (click)="refreshComponent()">
          <span class="bi bi-arrow-clockwise"></span>
          Refresh
        </button>
      </div>
      <div *ngIf="storageNameLoaded" class="flex-grow-1 h-100" style="position: relative;">
        <router-outlet></router-outlet>
      </div>
      <ngx-spinner
        bdColor="rgba(0,0,0,0)"
        size="default" zIndex = "1"
        color="var(--s-primary-color)"
        type="ball-spin"
        [fullScreen]="false"
        name="jobLoad"
        ><p>Please wait ...</p></ngx-spinner
      >
    </div>
  </div>
</div>
